module.exports = __webpack_public_path__ + "fonts/Merriweather-400-cyrillic13.655c184.woff2";